import { map } from 'lodash';

// App
import { app } from './utils/store';

// User Detect
import { DetectionManager } from './utils/detect';

// Cursor
// import { CursorManager } from './modules/cursor';

// Renderers
import Renderer from './renderers/renderer';

// AsyncLoad
import AsyncLoad from './classes/AsyncLoad';

// UI Components/Modules
// import Preload from './modules/preload/preload';
import Main from './modules/menu/main';
import Products from './modules/menu/products';
import Rooms from './modules/menu/rooms';

import Title from './animations/Title';
import Paragraph from './animations/Paragraph';
import Label from './animations/Label';

// Pages
import ArchiveStore from './pages/Store';
import SingleStore from './pages/Store/single';
import SingleProduct from './pages/Product/single';

class App {
    constructor() {
        app.init = true
        app.html = document.documentElement
        app.root = document.body
        app.viewport = document.querySelector('[data-app-viewport]')
        app.content = document.getElementById("app-content")
        app.current = document.body.getAttribute('data-template')

        //Async Load
        this.images = document.querySelectorAll('[data-src]')

        // Main
        if (document.querySelector('header')) {
            app.nav = new Main();

            // Products
            app.products = new Products();
            app.rooms = new Rooms();
        }
        // app.loader = new Preload();
        // app.loader.init();

        // Renderes
        app.renderer = new Renderer();
        app.renderer.init();

        // Pages
        this.createPages();

        // Only if is Desktop
        // if(app.device.desktop){ CursorManager.create(); }

        //Animations
        this.animated = {
            titles: document.querySelectorAll('[data-animation="title"]'),
            paragraphs: document.querySelectorAll('[data-animation="paragraph"]'),
            labels: document.querySelectorAll('[data-animation="label"]'),
        }

        this.createAnimations()
        this.createPreloaders()

        app.loading = false

        console.log(app)
    }

    // Create Pages
    createPages = () => {
        this.pages = {
            // Store
            archive_store: new ArchiveStore(),
            single_store: new SingleStore(),
            single_flagship: new SingleStore('single_flagship'),
            // Product
            single_product: new SingleProduct(),
        }

        this.page = this.pages[app.current]
        app.page = this.page

        if (app.page) {
            app.page.create()
        }
    }

    createAnimations() {
        this.animations = new Array();

        // Titles
        this.animationsTitles = map(this.animated.titles, (element) => {
            return new Title({ element })
        })
        this.animations.push(...this.animationsTitles);

        // Paragraphs
        this.animationsParagraphs = map(this.animated.paragraphs, (element) => {
            return new Paragraph({ element })
        })
        this.animations.push(...this.animationsParagraphs);

        // Labels
        this.animationsLabels = map(this.animated.labels, (element) => {
            return new Label({ element })
        })
        this.animations.push(...this.animationsLabels);
    }

    createPreloaders() {
        this.preloaders = map(this.images, element => {
            return new AsyncLoad({ element })
        })
    }
}

new App();